<template>
    <div class="stake-banner-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <div class="uk-section uk-section-xlarge">
            <h1 class="uk-text-center uk-visible@s">Earn <fa-icon icon="tractor"></fa-icon>FARM with <span>Harvest</span></h1>
            <h1 class="uk-text-center uk-hidden@s"><span id="mobile-title">Harvest</span></h1>
            <h2 class="uk-text-center">Stake your LP tokens for rewards</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: "StakeBanner",
    props: {
        mode: String
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/stake-banner.less";

    .uk-section {
        padding-left: .3em;
        padding-right: .3em;

        background-image: url("../../assets/banner-back.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    
        h1 {
            font-family: 'Lato';
            font-weight: 900;
            .fluid-font(2, 86, 320, 3840);
            color: @text-color;

            span {
                text-shadow: 
                    -1px -1px 0px lighten(@brand-color, 5%),
                    2px 2px 0px lighten(@brand-color, 5%),
                    3px 3px 0px darken(@brand-color, 2%);
            }
        }

        h2 {
            margin-top: 0;
            color: @text-color;
            font-family: 'Lato';
            font-weight: 900;
            .fluid-font(1.8, 64, 320, 3840);
        }
    }

    @media only screen and (max-width: 640px) {
        .uk-section {
            background-image: url("../../assets/banner-back-small.png");
        }
    }
</style>